var rtlLanguages = ['fa', 'ar', 'per', 'ara'];
var rtlCheckerAndSetter = function (lang) {
    if (rtlLanguages.includes(lang)) {
        document.documentElement.setAttribute('dir', 'rtl');
    }
    else {
        document.documentElement.setAttribute('dir', 'ltr');
    }
};

export { rtlCheckerAndSetter, rtlLanguages };
